import React from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';


const CommonPhoneInput = ({ 
  value, 
  onChange, 
  onBlur, 
  placeholder, 
  disabled, 
  country = 'in', 
  error 
}) => {
  // Helper to get dial code length from value
  const getDialCodeLength = (inputValue = '', countryCode = 'in') => {
    // react-phone-input-2 always prepends '+' to dial code
    // Find dial code for the country
    const dialCodes = {
      in: '91',
      us: '1',
      // Add more as needed
    };
    const dialCode = dialCodes[countryCode] || '';
    return dialCode ? (1 + dialCode.length) : 0; // + + dialCode
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Backspace') {
      const input = e.target;
      const dialCodeLength = getDialCodeLength(value, country);
      // Prevent backspace if cursor is at or before end of dial code
      if (input.selectionStart <= dialCodeLength) {
        e.preventDefault();
      }
    }
  };

  return (
    <div className="w-full">
      <PhoneInput
        country={country}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        disabled={disabled}
        placeholder={placeholder}
        enableSearch={true}
        disableSearchIcon={false}
        searchPlaceholder="Search country"
        countryCodeEditable={false}
        inputProps={{
          name: 'phone',
          required: false,
          autoFocus: false,
          onKeyDown: handleKeyDown,
        }}
        containerClass="!w-full"
        // ADDED: Conditional class logic for Red Border on error
        inputClass={`input input-shadow !w-full !h-9 !text-[14px] !font-lato !text-[#101828] !bg-white !rounded-lg !transition-all ${
          error 
            ? '!border-red-600 focus:!border-red-600' 
            : '!border-gray-300 focus:!shadow-outline focus:!border-[#FF8E1C]'
        }`}
        // ADDED: Conditional class logic for Button Red Border
        buttonClass={`!bg-white !rounded-l-lg hover:!bg-gray-50 ${
          error 
            ? '!border-red-600' 
            : '!border-gray-300'
        }`}
        dropdownClass="!shadow-lg !text-sm !font-lato"
        dropdownStyle={{ zIndex: 9999, textAlign: 'left' }}
      />
      {error && (
        <p className="text-xs text-red-600 mb-2 mt-1 text-left font-medium">{error}</p>
      )}
    </div>
  );
};

export default CommonPhoneInput;